import React, { useEffect, useState } from 'react';
import Typography from "@material-ui/core/Typography";
import { Button, useMediaQuery } from "@material-ui/core";
import { themeButtons } from "../../../css/themeButtons";
import { NavLink } from "react-router-dom";
import { RenderModalRoomDelete } from "../../ObjectRooms/ObjectRooms";
import { ReactSortable } from "react-sortablejs";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CardMedia from "@material-ui/core/CardMedia";
import noImg from "../../../asset/noImage.jpg";
import Box from "@material-ui/core/Box";

const RenderRoomAddCard = ({ objectId, goPage }) => {
  return (
    <Card className="card add-card add-object-room">
      <CardActionArea component={NavLink} to={`/lk/${objectId}/fastCreateObject?room=new`}
                      onClick={() => goPage("roomEdit")} className="d-flex w-100 h-100">
        <CardContent className={"add-object__icon"}>
          <FontAwesomeIcon icon={"plus"}/>

        </CardContent>
        <CardContent>
          <Typography className="add-object__text text-center" variant="h6">
            Добавить категорию номера
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}


const RenderRoomsCard = ({ objectId, id, name, image, confirmDeleteRoom, baseUrl, goPage, roomsCount }) => {

  return (
    <Card className="card card-object card-room h-100">
      {roomsCount > 1 && <Button className="btn card-delete " onClick={() => confirmDeleteRoom(id)}>
        <FontAwesomeIcon icon={"trash"}/>
      </Button>}

      <CardActionArea onClick={() => goPage("roomEdit")} className="h-100" component={NavLink}
                      to={`/lk/${objectId}/fastCreateObject?room=${id}`}>
        <CardMedia
          component="img"
          alt=""
          height="120"
          image={image.src ? `${baseUrl + image.src}` : noImg}

          title=""
        />
        <CardContent className="card-body p-2">
          <p className="card-title text-truncate">{name}</p>
        </CardContent>
      </CardActionArea>
      <CardActionArea className="card-btn" onClick={() => goPage("roomEdit")} component={NavLink}
                      to={`/lk/${objectId}/fastCreateObject?room=${id}`}>
        <Box className="text-center">
          Редактировать номер
        </Box>
      </CardActionArea>


    </Card>
  )
}


const RenderRoomsList = ({
  confirmDeleteRoom,
  roomsList,
  setRoomsList,
  toggleUnsavedPage,
  baseUrl,
  objectId,
  goPage
}) => {
  const mobileAgent = useMediaQuery('(max-width: 974px)') || window.matchMedia('(max-width: 974px)').matches;

  return (
    <div id="object-rooms" className="section">
      <ReactSortable animation={500} draggable=".card-sortable"
                     id="sortable"
                     disabled={mobileAgent}
                     onChange={() => toggleUnsavedPage(true)}
                     className="row cards-object row-cols-1 row-cols-md-3 row-cols-xl-4 row-cols-xxl-5 g-2 mb-3"
                     list={roomsList} setList={setRoomsList}>
        {roomsList.map((room, index) => (
          <div key={index} className={`col ${index !== 0 && "card-sortable"}`}>
            {index === 0
              ? <RenderRoomAddCard objectId={objectId} goPage={goPage}/>
              : <RenderRoomsCard {...room} confirmDeleteRoom={confirmDeleteRoom} goPage={goPage}
                                 baseUrl={baseUrl}
                                 roomsCount={roomsList.length - 1}
                                 objectId={objectId}/>
            }
          </div>
        ))}
      </ReactSortable>
    </div>
  )

}

const FastRooms = (props) => {
  const { objectId, savePage, roomsListFromBd, baseUrl, goPage } = props

  const [unsavedPage, toggleUnsavedPage] = useState(false)
  const [roomsList, setRoomsList] = useState([{}])
  const [deletedRoom, setDeletedRoom] = useState();
  const [deletedRooms, setDeletedRooms] = useState([]);

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [])

  useEffect(() => {
    if (!!roomsListFromBd) setRoomsList([{}, ...roomsListFromBd])
  }, [roomsListFromBd])

  let [show, toggleModalShow] = useState(false);


  //открытие/закрытие модалок
  const toggleShow = () => {
    toggleModalShow(!show)
  };

  //подтверждение удаления номера
  const confirmDeleteRoom = (roomId) => {
    setDeletedRoom(roomsList.filter(item => item.id === roomId))
    toggleModalShow(!show)
  }

  //удаления номера
  const deleteRoom = () => {
    toggleUnsavedPage(true)
    let newDeletedRooms = deletedRooms
    newDeletedRooms.push(deletedRoom[0].id)

    setDeletedRooms(newDeletedRooms)
    setRoomsList(roomsList.filter(item => item.id !== deletedRoom[0].id))
    toggleModalShow(!show)
  }


  //сохранение страницы
  const savePageHandler = async () => {
    if (unsavedPage) {
      toggleUnsavedPage(false)

      let rooms = roomsList.slice(1).map(item => item.id)

      let response = await savePage({
        object: objectId,
        section: "rooms",
        data: { rooms, deleted: deletedRooms }
      })

      if (response) {
        goPage("cm")
      }
    }
    goPage("cm")
  }

  const buttons = themeButtons();
  return (
    <div className="stepByStepWrp">
      <div className="stepByStepWrp__header">
        <Typography variant="h5" component="h5" className="stepByStepWrp__title">Категории номеров</Typography>
      </div>


      <div className="stepByStepWrp__body">
        <div className="navbar__object-id badge bg-success me-0 me-sm-2 mb-3">id: {objectId}</div>
        <RenderRoomsList confirmDeleteRoom={confirmDeleteRoom}
                         toggleUnsavedPage={toggleUnsavedPage}
                         roomsList={roomsList}
                         setRoomsList={setRoomsList}
                         baseUrl={baseUrl}
                         goPage={goPage}
                         objectId={objectId}/>


        {show && <RenderModalRoomDelete toggleShow={toggleShow}
                                        show={show}
                                        deletedRoomName={deletedRoom[0].name}
                                        deleteRoom={deleteRoom}/>}
      </div>


      <div className="stepByStepWrp__actions">
        <Button className={`btn`} onClick={() => goPage("rules")}>Назад</Button>
        <Button className={`btn ${buttons.btnGreen}`} disabled={roomsList.length <= 1}
                onClick={savePageHandler}>Сохранить и продолжить</Button>
      </div>
    </div>
  )
};


export default FastRooms;
